<template>
  <PageSlot>
    <template #pageslot-contents>
      <div class="aimusicchat-pagecontainer">
        <img class="white-dimimg" src="/media/images/white-dim.png" alt="white-dim.png" />
        <img class="aichannel-bgimg" src="/media/images/aichannel-img.jpeg" alt="aichannel-img.jpeg" />

        <!-- 대화 화면 -->
        <div class="max960-container aimusicchat-container" v-if="isSetSpaceName">
          <AiChat :aichanneltype="'aimusic'" :spaceid="spaceId" :spacename="spaceName" />
        </div>
      </div>
    </template>
  </PageSlot>
</template>
<script>
import PageSlot from '@/slot/PageSlot.vue';
import AiChat from '@/components/AiChat/AiChat.vue';
import { getMySpaceInfoV2 } from '@/service/api/myMenuApi';
export default {
  components: {
    PageSlot,
    AiChat
  },
  beforeRouteLeave(to, from, next) {
    this.$gatag.event('web_ai_chat_page_back_button'); // ai 채팅 페이지 뒤로가기 버튼
    next();
  },
  data() {
    return {
      userId: this.$cookies.get('userId'),
      spaceName: null,
      isSetSpaceName: false
    };
  },
  async created() {
    await this.getMySpaceInfo();
  },
  methods: {
    /**
     * @description 내 스페이스 정보 조회
     */
    async getMySpaceInfo() {
      try {
        const { data } = await getMySpaceInfoV2(this.spaceId, this.userId);
        const { resultCd, result } = data;
        if (resultCd === '0000') {
          this.spaceName = result.spaceNm;
          this.isSetSpaceName = true;
        } else {
          this.spaceName = '';
        }
      } catch (error) {
        console.log(error);
      }
    }
  },
  computed: {
    spaceId() {
      return this.$cookies.get('spaceId');
    }
  }
};
</script>
<style scoped src="@/assets/css/aimusicchat/aimusicchat.css"></style>
